import { render, staticRenderFns } from "./DoctorSumWard.vue?vue&type=template&id=35f3966d&"
import script from "./DoctorSumWard.vue?vue&type=script&lang=js&"
export * from "./DoctorSumWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports